import React, { useMemo, useState, useEffect, } from 'react';
import { Dimensions, Platform, StyleSheet, TouchableOpacity, View, } from 'react-native';
import { ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, StepperTypeTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { ModalAlignmentEnum, } from '@voltmoney/types';
import { isMobile } from '../../stack/utils';
import { getScreenType } from '../bankSelectPage/BankSelect';
import { Typography } from '../../typography/Typography';
import { Header } from '../../header/Header';
import { Stepper } from '../../stepper/Stepper';
import { Icon } from '../../icon/Icon';
import { Button } from '../../button/Button';
import BottomSheet from '../BottomSheet';
import LottieView from 'lottie-react-native';
import { WebView as WV } from "react-native-webview";
const BajajAgreementStepper = ({ height, backAction, triggerAction, stepperData, bajajAgreementStepperData, continueAction, loading, agreementAction, showClickForAgreementCard, openTabAction, showWaitingForResponseCard, pollAgreementStatusAction, showAgreementCompleteStatus, showAgreementFailureStatus, verificationSuccessAction, kfsSuccessAction, showKfsCancelledStatus, showKfsCompletedStatus, showWebView, agreementUrl, kfsCancelAction, showNewAgreementFlow, goToAgreementPage, counter, closeFailureCardAction, }) => {
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null,
    };
    const [successLottie, setSuccessLottie] = useState('');
    const [iLottieFetched, setLottieFetched] = useState(false);
    const [showFailureCard, setShowFailureCard] = useState(false);
    const [showNewAgreementFlowDc, setShowNewAgreementFlowDc] = useState(showNewAgreementFlow);
    const successJsonLottie = 'https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json';
    useEffect(() => {
        fetch(successJsonLottie, {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((responseData) => {
            setSuccessLottie(responseData);
            setLottieFetched(true);
        })
            .catch((error) => {
            console.log(error);
        });
    }, []);
    useEffect(() => {
        setShowNewAgreementFlowDc(showNewAgreementFlow);
        setShowFailureCard(showAgreementFailureStatus);
    }, [counter, showNewAgreementFlow, showAgreementFailureStatus]);
    useEffect(() => {
        if (showNewAgreementFlowDc) {
            setTimeout(async () => {
                await triggerAction(openTabAction);
            }, 2000);
        }
    }, [showNewAgreementFlowDc]);
    const handleFailureCard = async () => {
        setShowFailureCard(true);
        await triggerAction(closeFailureCardAction);
    };
    const _headerChild = useMemo(() => {
        return (React.createElement(Header, { id: 'bt_bajajAgreementStepper_goBack', type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, title: 'Review agreement', onPress: () => {
                if (backAction) {
                    triggerAction(backAction);
                }
            } }));
    }, []);
    const renderKfsSuccessCard = () => {
        return (React.createElement(View, { style: styles.successCard },
            Platform.OS === 'ios'
                && React.createElement(LottieView, { source: { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" }, style: { width: 80, height: 80 }, autoPlay: true, loop: true }),
            Platform.OS !== 'ios'
                && successLottie !== ""
                && React.createElement(LottieView, { source: successLottie, style: styles.successLottie, autoPlay: true, loop: true }),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'Key terms accepted!' })),
            React.createElement(View, { style: { marginTop: 4, marginBottom: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: ' You will be redirected to next step in few seconds' })),
            React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: 'Continue', onPress: () => {
                    if (kfsSuccessAction) {
                        triggerAction(kfsSuccessAction);
                    }
                } })));
    };
    const renderContinueAgreementCard = () => {
        return (React.createElement(View, { style: styles.successCard },
            React.createElement(Icon, { name: IconTokens.Redirecting, size: IconSizeTokens.Size56 }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: 'Please click continue for agreement', fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'Return to Volt after successful completion', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.successCTA },
                React.createElement(Button, { id: 'bt_bajajAgreementStepper_continue', type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Continue', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        triggerAction({
                            ...openTabAction,
                        });
                    }, loading: loading }))));
    };
    const renderWaitingHalfCard = () => {
        return (React.createElement(View, { style: styles.successCard },
            React.createElement(Icon, { name: IconTokens.Redirecting, size: IconSizeTokens.Size56 }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: 'Waiting for response', fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'Please wait while we process your request', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 }))));
    };
    const renderVerificationSuccess = () => {
        return (React.createElement(View, { style: styles.successCard },
            React.createElement(LottieView, { source: successLottie, style: styles.successLottie, autoPlay: true, loop: true }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: 'Agreement submitted!', fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'You are almost done! Continue to the next step', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.successCTA },
                React.createElement(Button, { id: 'bt_bajajAgreementStepper_success', type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Proceed', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        triggerAction({
                            ...verificationSuccessAction,
                        });
                    } }))));
    };
    const renderVerificationFailure = () => {
        return (React.createElement(View, { style: styles.successCard },
            React.createElement(Icon, { name: IconTokens.SystemError, size: IconSizeTokens.XXXXXXL }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: 'Agreement signing failed', fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'We encountered an error while signing the loan agreement. Please retry the process.', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.successCTA },
                React.createElement(Button, { id: 'bt_bajajAgreementStepper_tryAgain', type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Continue to try again', width: ButtonWidthTypeToken.FULL, onPress: handleFailureCard }))));
    };
    const renderCancelKfs = () => {
        return (React.createElement(View, { style: styles.successCard },
            React.createElement(Icon, { name: IconTokens.SystemError, size: IconSizeTokens.XXXXXXL }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: 'Kfs failed', fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'Action was cancelled by the user', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.successCTA },
                React.createElement(Button, { id: 'bt_bajajAgreementStepper_tryAgain', type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Continue to try again', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        if (kfsCancelAction) {
                            triggerAction(kfsCancelAction);
                        }
                    } }))));
    };
    const renderVerificationKfs = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: 230, width: '100%', closeFunction: () => {
                    if (kfsCancelAction) {
                        triggerAction(kfsCancelAction);
                    }
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: showKfsCancelledStatus ? true : false, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Platform.OS !== 'ios'
                        ? Dimensions.get('window').height + 10
                        : Dimensions.get('window').height
                    : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 508, routeId: 'routeId', handleKeyboard: true }, showKfsCancelledStatus ? renderCancelKfs() : renderKfsSuccessCard())));
    };
    const renderSuccessCard = () => {
        return (React.createElement(View, { style: {
                padding: 16,
                width: '100%',
                alignContent: 'center',
                alignSelf: 'center',
                alignItems: 'center',
                height: 230,
                position: 'absolute',
                bottom: 0,
            } },
            Platform.OS === 'ios'
                && React.createElement(LottieView, { source: { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" }, style: { width: 80, height: 80 }, autoPlay: true, loop: true }),
            Platform.OS !== 'ios'
                && successLottie !== ""
                && React.createElement(LottieView, { source: successLottie, style: styles.successLottie, autoPlay: true, loop: true }),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'Key terms accepted!' })),
            React.createElement(View, { style: { marginTop: 4, marginBottom: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: ' You will be redirected to next step in few seconds' })),
            React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, label: 'Continue', onPress: () => {
                } })));
    };
    const renderVerification = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: showWaitingForResponseCard ? 200 : 260, width: '100%', closeFunction: () => {
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: false, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Platform.OS !== 'ios'
                        ? Dimensions.get('window').height + 10
                        : Dimensions.get('window').height
                    : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 508, routeId: 'routeId', handleKeyboard: true }, showAgreementCompleteStatus &&
                iLottieFetched
                ? renderVerificationSuccess()
                : showWaitingForResponseCard
                    ? renderWaitingHalfCard()
                    : (showAgreementFailureStatus && showFailureCard)
                        ? renderVerificationFailure()
                        : renderContinueAgreementCard())));
    };
    const showWaitingAgreementPage = () => {
        return (React.createElement(View, { style: { height: height - 16, display: 'flex', justifyContent: 'center' } },
            React.createElement(View, { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.PENDING_AGREEMENT, size: IconSizeTokens.XXXXXXXXL }),
                React.createElement(View, { style: { marginTop: 16 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: 'Waiting for agreement completion' }))),
            React.createElement(View, { style: { marginTop: 32, marginHorizontal: 8 } },
                React.createElement(View, { style: { flexDirection: 'row', flexShrink: 1, alignItems: 'center' } },
                    React.createElement(View, { style: { width: 32, height: 32, borderRadius: 100, alignItems: 'center', justifyContent: 'center', marginRight: 16, backgroundColor: '#F1F3F5' } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: '1' })),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'You will be redirected to the agreement page' }))),
            React.createElement(View, { style: { marginTop: 16, marginHorizontal: 8 } },
                React.createElement(View, { style: { flexDirection: 'row', flexShrink: 1, alignItems: 'center' } },
                    React.createElement(View, { style: { width: 32, height: 32, borderRadius: 100, alignItems: 'center', justifyContent: 'center', marginRight: 16, backgroundColor: '#F1F3F5' } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: '2' })),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Review & sign the loan agreement' }))),
            React.createElement(View, { style: { marginTop: 16, marginHorizontal: 8 } },
                React.createElement(View, { style: { flexDirection: 'row', flexShrink: 1, alignItems: 'center' } },
                    React.createElement(View, { style: { width: 32, height: 32, borderRadius: 100, alignItems: 'center', justifyContent: 'center', marginRight: 16, backgroundColor: '#F1F3F5' } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: '3' })),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'You will be redirected back to continue' }))),
            React.createElement(View, { style: { position: 'absolute', bottom: 16, left: 0, right: 0, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', display: 'flex' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Agreement not completed?' }),
                React.createElement(TouchableOpacity, { style: { marginLeft: 4 }, onPress: async () => {
                        if (goToAgreementPage) {
                            await triggerAction(goToAgreementPage);
                        }
                    } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: 'Click here', color: ColorTokens.Primary_100 })))));
    };
    const renderAgreementPage = () => {
        return (React.createElement(View, { style: [
                styles.container,
                {
                    height: Platform.OS === 'ios'
                        ? height - 36
                        : height - 20,
                },
            ] },
            React.createElement(View, { style: styles.headerStyle }, _headerChild),
            showWebView ?
                React.createElement(WV, { id: 'iframe', style: {
                        width: Dimensions.get('window').width,
                        height: height - 150,
                    }, automaticallyAdjustContentInsets: false, javaScriptEnabled: true, domStorageEnabled: true, startInLoadingState: true, useWebKit: true, originWhitelist: ['*'], allowsInlineMediaPlayback: true, scalesPageToFit: Platform.OS === 'android', scrollEnabled: true, mediaPlaybackRequiresUserAction: false, javaScriptEnabledAndroid: true, source: { uri: agreementUrl }, showsHorizontalScrollIndicator: false, nestedScrollEnabled: Platform.OS !== "web" })
                :
                    React.createElement(View, { style: { paddingHorizontal: 16 } },
                        React.createElement(View, { style: { marginTop: 24, marginBottom: 24 } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4B, label: 'Verify key terms & sign agreement', color: ColorTokens.Grey_Night })),
                        React.createElement(Stepper, { type: StepperTypeTokens.VERTICAL, data: bajajAgreementStepperData })),
            !showWebView && React.createElement(View, { style: styles.bottomContainer },
                React.createElement(Button, { id: 'bt_bajajAgreementStepper_continue', type: ButtonTypeTokens.LargeFilled, label: bajajAgreementStepperData[0].status ===
                        'COMPLETED'
                        ? 'Continue to sign agreement'
                        : 'Continue', fontSize: FontSizeTokens.SM, width: ButtonWidthTypeToken.FULL, loading: loading, onPress: () => {
                        if (continueAction) {
                            if (bajajAgreementStepperData[0].status ===
                                'COMPLETED') {
                                if (agreementAction)
                                    triggerAction({
                                        ...agreementAction,
                                    });
                            }
                            else {
                                triggerAction({
                                    ...continueAction,
                                });
                            }
                        }
                    } }),
                React.createElement(View, { style: {
                        marginTop: 12,
                        borderRadius: 4,
                        borderColor: '#E4E7EC',
                        flexDirection: 'row',
                        borderWidth: 1,
                        alignSelf: 'center',
                        alignItems: 'center',
                    } },
                    React.createElement(View, { style: {
                            borderRightWidth: 1,
                            padding: 8,
                            borderRightColor: '#E4E7EC',
                            justifyContent: 'center',
                            alignContent: 'center',
                            alignItems: 'center',
                        } },
                        React.createElement(Typography, { label: 'Lending partner', fontSize: FontSizeTokens.XXS, fontWeight: '400', lineHeight: 16, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal })),
                    React.createElement(View, { style: { paddingHorizontal: 8 } },
                        React.createElement(Icon, { name: IconTokens.BAJAJ_FULL_LOGO_NEW, color: ColorTokens.Grey_Charcoal })))),
            (showClickForAgreementCard ||
                showWaitingForResponseCard ||
                showAgreementCompleteStatus ||
                showKfsCompletedStatus ||
                showKfsCancelledStatus
                ||
                    showAgreementFailureStatus) && !showWebView && !showKfsCancelledStatus && !showKfsCompletedStatus &&
                renderVerification(),
            (showKfsCancelledStatus || showKfsCompletedStatus) && renderVerificationKfs()));
    };
    if (Platform.OS === 'android' || Platform.OS === 'ios') {
        return renderAgreementPage();
    }
    return showNewAgreementFlowDc ? showWaitingAgreementPage() : renderAgreementPage();
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height - 114,
        marginHorizontal: -16,
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    headerStyle: {
        ...(Platform.OS === 'ios' && {
            marginTop: 24,
        }),
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        paddingHorizontal: 16,
        ...(Platform.OS === 'ios' && { marginTop: 24 }),
        flex: 1, // pushes the footer to the end of the screen
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14,
    },
    bottomContainer: {
        position: 'absolute',
        bottom: 0,
        padding: 16,
        marginTop: 5,
        width: '100%',
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        borderTopWidth: 1,
        borderColor: '#F1F3F5',
        paddingVertical: 16,
        backgroundColor: 'white',
    },
    securityView: {
        flexDirection: 'row',
        marginBottom: 8,
    },
    successCard: {
        alignItems: 'center',
        flex: 1,
        height: 230,
        padding: 16,
    },
    successLottie: { width: 70, height: 'auto' },
    halfCardTitle: { marginTop: 16 },
    halfCardDescription: { marginTop: 4 },
    successCTA: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        paddingHorizontal: 16,
        marginBottom: 16,
        marginTop: 24,
    },
});
export default BajajAgreementStepper;
